import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../shadcn/ui/dialog";
import { Button } from "../shadcn/ui/button";
import LoadingSpinner from "./LoadingSpinner";

const ReusableFormModal = ({
  isOpen,
  onClose,
  title,
  isLoading = false,
  loadingText = "Loading...",
  onSubmit,
  submitText = "Save",
  cancelText = "Cancel",
  isSubmitting = false,
  submitButtonDisabled = false,
  children,
  maxWidth = "max-w-4xl",
  showCloseButton = true,
}) => {
  const handleClose = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className={`${maxWidth} max-h-[90vh] overflow-y-auto`}>
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">{title}</DialogTitle>
        </DialogHeader>

        {/* Loading spinner */}
        {isLoading && (
          <div className="flex justify-center items-center py-8">
            <LoadingSpinner />
            <span className="ml-2 text-sm text-gray-600">{loadingText}</span>
          </div>
        )}

        {/* Show form only when not loading */}
        {!isLoading && (
          <form onSubmit={onSubmit}>
            {children}

            <DialogFooter className="flex justify-end space-x-3">
              <Button type="button" variant="outline" onClick={handleClose} disabled={isSubmitting}>
                {cancelText}
              </Button>
              <Button type="submit" disabled={isSubmitting || submitButtonDisabled} variant="default">
                {isSubmitting ? "Saving..." : submitText}
              </Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReusableFormModal;
